import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { selectDashboardInfo } from "../../../state/ducks/dashboard";
import $ from "jquery";
import { beginLogout } from "../../../state/ducks/login/index";

class Menu extends Component {
  beginLogout = () => {
    this.props.beginLogout();
  };

  closeMenu = () => {
    $("#mobilmenu").collapse("hide");
  };

  collapseAllSubMenus = (exceptGroupIndexes = []) => {
    [1, 2, 3].forEach((index) => {
      if (exceptGroupIndexes.includes(index)) return;

      [`menu${index}`, `mobil_menu${index}`].forEach((panelId) => {
        const panel = document.getElementById(panelId);
        if (panel?.classList.contains("show")) {
          $(`#${panelId}`).collapse("hide");
        }
      });
    });
  };

  handleNavClick = (keepOpenGroupIndex = null) => {
    const groupIndex = typeof keepOpenGroupIndex === "number" ? keepOpenGroupIndex : null;
    const exceptGroupIndexes = groupIndex ? [groupIndex] : [];
    this.collapseAllSubMenus(exceptGroupIndexes);
    this.closeMenu();
  };

  getMenuPanelId = (index) => {
    const { accordionId = "sol_menu" } = this.props;
    return accordionId === "ust_menu" ? `mobil_menu${index}` : `menu${index}`;
  };

  componentDidMount() {
    this.expandActiveGroups();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location?.pathname !== this.props.location?.pathname) {
      this.expandActiveGroups();
    }
  }

  expandActiveGroups = () => {
    [1, 2, 3].forEach((index) => {
      [`menu${index}`, `mobil_menu${index}`].forEach((panelId) => {
        const panel = document.getElementById(panelId);
        if (!panel) return;

        const hasActive = panel.querySelector(".t-appNav-link.is-active");
        if (hasActive) {
          $(`#${panelId}`).collapse("show");
        } else {
          $(`#${panelId}`).collapse("hide");
        }
      });
    });
  };

  getCurrentPath = () => (this.props.location?.pathname || "").toLowerCase();

  isPathActive = (path, exact = true) => {
    const current = this.getCurrentPath();
    const target = (path || "").toLowerCase();
    return exact ? current === target : current.startsWith(target);
  };

  getNavLinkClass = (path, exact = true) =>
    `t-appNav-link${this.isPathActive(path, exact) ? " is-active" : ""}`;

  getNavLinkClassForPaths = (paths) => {
    const isActive = paths.some((path) => this.isPathActive(path));
    return `t-appNav-link${isActive ? " is-active" : ""}`;
  };

  getTalimatVerActivePaths = () => {
    const { dashboard } = this.props;

    if (dashboard?.isInstallmentPayment) {
      return [
        "/Home/CreatePayment",
        "/Home/CreatePaymentOrder",
        "/Home/CreatePaymentOrderPayFor",
        "/Home/CreatePaymentOrderPayTr",
        "/Home/CreatePaymentOrderEminPay",
      ];
    }

    if (dashboard?.oneShotPaymentBankType === "0") {
      return ["/Home/CreatePaymentOrder"];
    }

    if (dashboard?.oneShotPaymentBankType === "1") {
      return ["/Home/CreatePaymentOrderPayFor"];
    }

    if (dashboard?.oneShotPaymentBankType === "2") {
      return ["/Home/CreatePaymentOrderPayTr"];
    }

    if (dashboard?.oneShotPaymentBankType === "3") {
      return ["/Home/CreatePaymentOrderEminPay"];
    }

    return [];
  };

  getGroupToggleClass = (paths) => {
    const isActive = paths.some((path) => this.isPathActive(path));
    return `t-appNav-groupToggle${isActive ? " is-active" : ""}`;
  };

  renderNavBadge = (value) => {
    if (value === undefined || value === null || value === "" || Number(value) === 0) return null;
    return <span className="t-appNav-badge">{value}</span>;
  };

  renderNavIcon = (iconClass) => (
    <span className="t-appNav-iconWrap">
      <i className={iconClass} aria-hidden="true" />
    </span>
  );

  renderTalimatVer = () => {
    const { dashboard } = this.props;
    const talimatVerClass = this.getNavLinkClassForPaths(this.getTalimatVerActivePaths());

    if (dashboard?.isInstallmentPayment) {
      return (
        <Link to="/Home/CreatePayment" className={talimatVerClass} onClick={() => this.handleNavClick(3)}>
          {this.renderNavIcon("t-icon-plus-alt")}
          <span className="t-appNav-label">Talimat Ver</span>
        </Link>
      );
    }

    if (dashboard?.oneShotPaymentBankType === "0") {
      return (
        <Link
          to="/Home/CreatePaymentOrder"
          className={talimatVerClass}
          onClick={() => this.handleNavClick(3)}
        >
          {this.renderNavIcon("t-icon-plus-alt")}
          <span className="t-appNav-label">Talimat Ver</span>
        </Link>
      );
    }

    if (dashboard?.oneShotPaymentBankType === "1") {
      return (
        <Link
          to="/Home/CreatePaymentOrderPayFor"
          className={talimatVerClass}
          onClick={() => this.handleNavClick(3)}
        >
          {this.renderNavIcon("t-icon-plus-alt")}
          <span className="t-appNav-label">Talimat Ver</span>
        </Link>
      );
    }

    if (dashboard?.oneShotPaymentBankType === "2") {
      return (
        <Link
          to={{
            pathname: "/Home/CreatePaymentOrderPayTr",
            state: { paymentType: 1 },
          }}
          className={talimatVerClass}
          onClick={() => this.handleNavClick(3)}
        >
          {this.renderNavIcon("t-icon-plus-alt")}
          <span className="t-appNav-label">Talimat Ver</span>
        </Link>
      );
    }

    if (dashboard?.oneShotPaymentBankType === "3") {
      return (
        <Link
          to={{
            pathname: "/Home/CreatePaymentOrderEminPay",
            state: { paymentType: 1 },
          }}
          className={talimatVerClass}
          onClick={() => this.handleNavClick(3)}
        >
          {this.renderNavIcon("t-icon-plus-alt")}
          <span className="t-appNav-label">Talimat Ver</span>
        </Link>
      );
    }

    return null;
  };

  render() {
    const { dashboard, isCandidateCustomer, accordionId = "sol_menu" } = this.props;
    const profilePanelId = this.getMenuPanelId(1);
    const referencePanelId = this.getMenuPanelId(2);
    const paymentPanelId = this.getMenuPanelId(3);
    const profilePaths = ["/home/accountinfo", "/home/agentinfo", "/home/resetpassword"];
    const referencePaths = ["/home/submitreference", "/home/myreferences", "/home/referencerules"];
    const paymentPaths = [
      "/home/createpayment",
      "/home/createpaymentorder",
      "/home/createpaymentorderpayfor",
      "/home/createpaymentorderpaytr",
      "/home/createpaymentordereminpay",
      "/home/listpayments",
    ];

    return (
      <>
        <li className="t-appNav-item">
          <Link to="/Home/DashBoard" className={this.getNavLinkClass("/Home/DashBoard")} onClick={() => this.handleNavClick()}>
            {this.renderNavIcon("t-icon-home4")}
            <span className="t-appNav-label">Ana Sayfa</span>
          </Link>
        </li>

        <li className="t-appNav-item t-appNav-item--group">
          <button
            type="button"
            className={this.getGroupToggleClass(profilePaths)}
            data-toggle="collapse"
            data-target={`#${profilePanelId}`}
            aria-expanded="false"
            aria-controls={profilePanelId}
          >
            {this.renderNavIcon("t-icon-user1")}
            <span className="t-appNav-label">Profilim</span>
            <i className="t-icon-keyboard_arrow_down t-appNav-chevron" aria-hidden="true" />
          </button>
        </li>
        <div id={profilePanelId} className="collapse t-appNav-subPanel" data-parent={`#${accordionId}`}>
          <ul className="t-appNav-subList">
            <li className="t-appNav-subItem">
              <Link to="/Home/AccountInfo" className={this.getNavLinkClass("/Home/AccountInfo")} onClick={() => this.handleNavClick(1)}>
                {this.renderNavIcon("t-icon-info")}
                <span className="t-appNav-label">Bilgilerim</span>
              </Link>
            </li>
            <li className="t-appNav-subItem">
              <Link to="/Home/AgentInfo" className={this.getNavLinkClass("/Home/AgentInfo")} onClick={() => this.handleNavClick(1)}>
                {this.renderNavIcon("t-icon-user-tie")}
                <span className="t-appNav-label">Temsilci Bilgileri</span>
              </Link>
            </li>
            <li className="t-appNav-subItem">
              <Link to="/Home/ResetPassword" className={this.getNavLinkClass("/Home/ResetPassword")} onClick={() => this.handleNavClick(1)}>
                {this.renderNavIcon("t-icon-key-fill")}
                <span className="t-appNav-label">Şifre İşlemlerim</span>
              </Link>
            </li>
          </ul>
        </div>

        {!isCandidateCustomer && (
          <li className="t-appNav-item">
            <Link to="/Home/MemberInfo" className={this.getNavLinkClass("/Home/MemberInfo")} onClick={() => this.handleNavClick()}>
              {this.renderNavIcon("t-icon-info1")}
              <span className="t-appNav-label">Üyelik Bilgilerim</span>
              {this.renderNavBadge(dashboard?.menuCount?.memberCount)}
            </Link>
          </li>
        )}

        {dashboard.hasOwnAgent && (
          <>
            <li className="t-appNav-item t-appNav-item--group">
              <button
                type="button"
                className={this.getGroupToggleClass(referencePaths)}
                data-toggle="collapse"
                data-target={`#${referencePanelId}`}
                aria-expanded="false"
                aria-controls={referencePanelId}
              >
                {this.renderNavIcon("t-icon-users1")}
                <span className="t-appNav-label">Referanslar</span>
                <i className="t-icon-keyboard_arrow_down t-appNav-chevron" aria-hidden="true" />
              </button>
            </li>
            <div id={referencePanelId} className="collapse t-appNav-subPanel" data-parent={`#${accordionId}`}>
              <ul className="t-appNav-subList">
                <li className="t-appNav-subItem">
                  <Link
                    to="/Home/SubmitReference"
                    className={this.getNavLinkClass("/Home/SubmitReference")}
                    onClick={() => this.handleNavClick(2)}
                  >
                    {this.renderNavIcon("t-icon-add")}
                    <span className="t-appNav-label">Referans Giriş</span>
                  </Link>
                </li>
                <li className="t-appNav-subItem">
                  <Link
                    to="/Home/MyReferences"
                    className={this.getNavLinkClass("/Home/MyReferences")}
                    onClick={() => this.handleNavClick(2)}
                  >
                    {this.renderNavIcon("t-icon-users1")}
                    <span className="t-appNav-label">Referanslarım</span>
                  </Link>
                </li>
              </ul>
            </div>
          </>
        )}

        {dashboard?.hiddenMenu?.showPaymentOrder && (
          <>
            <li className="t-appNav-item t-appNav-item--group">
              <button
                type="button"
                className={this.getGroupToggleClass(paymentPaths)}
                data-toggle="collapse"
                data-target={`#${paymentPanelId}`}
                aria-expanded="false"
                aria-controls={paymentPanelId}
              >
                {this.renderNavIcon("t-icon-clipboard")}
                <span className="t-appNav-label">Ödeme Talimatı</span>
                <i className="t-icon-keyboard_arrow_down t-appNav-chevron" aria-hidden="true" />
              </button>
            </li>
            <div id={paymentPanelId} className="collapse t-appNav-subPanel" data-parent={`#${accordionId}`}>
              <ul className="t-appNav-subList">
                <li className="t-appNav-subItem">{this.renderTalimatVer()}</li>
                <li className="t-appNav-subItem">
                  <Link
                    to="/Home/ListPayments"
                    className={this.getNavLinkClass("/Home/ListPayments")}
                    onClick={() => this.handleNavClick(3)}
                  >
                    {this.renderNavIcon("t-icon-document-fill")}
                    <span className="t-appNav-label">Talimatlarım</span>
                  </Link>
                </li>
              </ul>
            </div>
          </>
        )}

        <li className="t-appNav-item">
          <Link to="/Home/SubmitDemand" className={this.getNavLinkClass("/Home/SubmitDemand")} onClick={() => this.handleNavClick()}>
            {this.renderNavIcon("t-icon-chat-alt-stroke")}
            <span className="t-appNav-label">Öneri ve İstek Bildirimi</span>
          </Link>
        </li>

        <li className="t-appNav-item">
          <Link to="/Home/MyDemands" className={this.getNavLinkClass("/Home/MyDemands")} onClick={() => this.handleNavClick()}>
            {this.renderNavIcon("t-icon-search2")}
            <span className="t-appNav-label">Talep Takibi</span>
            {this.renderNavBadge(dashboard?.menuCount?.demandCount)}
          </Link>
        </li>

        <li className="t-appNav-item">
          <Link to="/Home/Questions" className={this.getNavLinkClass("/Home/Questions")} onClick={() => this.handleNavClick()}>
            {this.renderNavIcon("t-icon-question1")}
            <span className="t-appNav-label">Sıkça Sorulan Sorular</span>
          </Link>
        </li>

        <li className="t-appNav-item">
          <a
            href="https://www.eminevim.com/banka-hesap-numaralarimiz"
            target="_blank"
            rel="noopener noreferrer"
            className="t-appNav-link t-appNav-link--external"
            onClick={() => this.handleNavClick()}
          >
            {this.renderNavIcon("t-icon-library")}
            <span className="t-appNav-label">Banka Bilgilerimiz</span>
            <i className="t-icon-launch t-appNav-externalIcon" aria-hidden="true" />
          </a>
        </li>

        {dashboard.isShowMemberApplication && (
          <li className="t-appNav-item">
            <Link
              id="hesaplama-yap"
              to="/Home/SmartCalculation"
              className={this.getNavLinkClass("/Home/SmartCalculation")}
              onClick={() => this.handleNavClick()}
            >
              {this.renderNavIcon("t-icon-calculator")}
              <span className="t-appNav-label">Hesaplama Yap</span>
              <span className="t-appNav-badge t-appNav-badge--new">Yeni</span>
            </Link>
          </li>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  dashboard: selectDashboardInfo(state),
  isCandidateCustomer: state.dashboard.isCandidateCustomer,
});

const mapDispatchToProps = (dispatch) => ({
  beginLogout: () => dispatch(beginLogout()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Menu));
